<template>
    <span>
        <i v-if="isCheck" class="uk-icon-check green"></i>
        <i v-else class="uk-icon-times red"></i>
    </span>
</template>

<script>
export default {
    props: {
        isCheck: {
            type: Boolean
        }
    }
}
</script>

<style lang="sass" scoped>
    .green
        color: #27ae60
    .red
        color: #e74c3c
</style>